/* eslint-disable react/jsx-props-no-spreading */
import { type FC, lazy, Suspense, useState } from "react";
import { useFormContext } from "react-hook-form";
import { UnstyledButton, ValidationErrorMessage } from "@legacy_user_frontend/components/ui_parts";
import { type PhotoProps } from "@legacy_user_frontend/components/pages/mypage/profiles/product_photo_edit/src/product_photo_edit_props";
import * as styles from "@legacy_user_frontend/components/pages/mypage/profiles/product_photo_edit/src/styles.css";
import { textAndLineBreakLength } from "@legacy_user_frontend/components/pages/mypage/profiles/product_photo_edit/src/modules";
import { retryLazyLoad } from "@root/shared/utils/retryLazyLoad";

const ConfirmModal = lazy(() =>
  retryLazyLoad({
    fn: () => import("./confirm_modal"),
  }),
);
const PreviewModal = lazy(() =>
  retryLazyLoad({
    fn: () => import("./preview_modal"),
  }),
);

export const Photo: FC<PhotoProps> = ({ photoIndex, imageUrl, maxLength, remove, dbId }) => {
  const { register, formState, clearErrors, watch } = useFormContext();
  const errors = formState.errors.product_photos_update?.product_photos_attributes;
  const currentErrors = errors && errors[photoIndex] ? errors[photoIndex] : null;
  const descriptionName = `product_photos_update[product_photos_attributes][${photoIndex}][description]`;
  const watchedDescription: string | null = watch(descriptionName);

  // プレビュー用画像パスの指定と画像プレビューモーダルの開閉
  const [previewPhoto, setPreviewPhoto] = useState<string | null>(null);
  const openPhotoModal = () => {
    setPreviewPhoto(imageUrl);
  };
  const closePhotoModal = () => setPreviewPhoto(null);

  // 削除確認モーダルの開閉
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const openDeleteModal = () => {
    setIsConfirmModalOpen(true);
  };
  const closeConfirmModal = () => setIsConfirmModalOpen(false);

  // 削除の実行
  const handleOnClick = () => {
    remove(photoIndex, imageUrl);
  };
  return (
    <div className={styles.cassetteOuter}>
      <div className={styles.cassette}>
        <div className={styles.cassetteHeading}>
          <p>画像{photoIndex + 1}</p>
          <UnstyledButton type="button" onClick={openDeleteModal} />
        </div>
        <div className={styles.cassetteContent}>
          <div className={styles.imageOuter}>
            <button type="button" onClick={openPhotoModal}>
              <img src={imageUrl} alt="" />
            </button>
          </div>
          {dbId !== undefined && (
            <input
              type="hidden"
              {...register(`product_photos_update[product_photos_attributes][${photoIndex}][id]`)}
            />
          )}
          <input
            type="hidden"
            {...register(`product_photos_update[product_photos_attributes][${photoIndex}][image]`)}
          />
          <div
            className={`${styles.textAreaOuter} ${currentErrors?.description ? styles.textAreaOuterError : ""}`}
          >
            <textarea
              placeholder="説明を追加できます"
              {...register(descriptionName, {
                onChange: () => clearErrors(descriptionName),
              })}
            />
            <div className={styles.textCountOuter}>
              <div>
                {currentErrors && (
                  <>
                    {currentErrors.image && (
                      <ValidationErrorMessage message={currentErrors.image.message} />
                    )}
                    {currentErrors.description && (
                      <ValidationErrorMessage message={currentErrors.description.message} />
                    )}
                  </>
                )}
              </div>
              <div>
                {watchedDescription ? textAndLineBreakLength(watchedDescription) : 0}/{maxLength}
                文字入力
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={null}>
        {previewPhoto && (
          <PreviewModal
            isOpen={!!previewPhoto}
            onRequestClose={closePhotoModal}
            photoPath={previewPhoto}
            heading="画像"
          />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {isConfirmModalOpen && (
          <ConfirmModal
            isModalOpen={isConfirmModalOpen}
            closeModal={closeConfirmModal}
            photoIndex={photoIndex}
            handleOnClick={handleOnClick}
          />
        )}
      </Suspense>
    </div>
  );
};
